import { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '~/services/auth-service';

export default function AuthLogin() {
  const { instance } = useMsal();

  useEffect(() => {
    // Redirect to Azure AD login
    instance.loginRedirect(loginRequest).catch(console.error);
  }, [instance]);

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h2>Redirecting to login...</h2>
      <p>You will be redirected to Microsoft sign in.</p>
    </div>
  );
}
